import { ReactElement, useEffect } from 'react'
import { DoubleSide, TextureLoader } from 'three'
import { useLoader } from '@react-three/fiber'

interface Props {
  url: string
  x0: number
  yTop: number
  titleBandHeight: number
  totalHeight: number
  width: number
  z: number
  onAspectRatioKnown: (aspectRatio: number) => void
}

const PlanImageCardImagePlane = ({
  url,
  x0,
  yTop,
  titleBandHeight,
  totalHeight,
  width,
  z,
  onAspectRatioKnown,
}: Props): ReactElement => {
  const texture = useLoader(TextureLoader, url)
  const imageHeight = Math.max(totalHeight - titleBandHeight, 0.01)
  const imageCenterY = yTop - titleBandHeight - imageHeight / 2

  useEffect(() => {
    const image = texture.image as HTMLImageElement | undefined
    if (image?.naturalWidth && image.naturalHeight) {
      onAspectRatioKnown(image.naturalWidth / image.naturalHeight)
    }
  }, [onAspectRatioKnown, texture])

  return (
    <mesh position={[x0 + width / 2, imageCenterY, z]}>
      <planeGeometry args={[width, imageHeight]} />
      <meshBasicMaterial map={texture} transparent depthWrite={false} side={DoubleSide} />
    </mesh>
  )
}

export default PlanImageCardImagePlane
